type LocalStreamLikeValue =
    | {
          type: "success";
          stream: MediaStream | undefined;
      }
    | {
          type: "error";
          error: Error;
      };

export const EMPTY_LOCAL_STREAM_VALUE: {
    type: "success";
    stream: MediaStream | undefined;
} = {
    type: "success",
    stream: undefined,
};

export function normalizeLocalStreamValue<T extends LocalStreamLikeValue>(
    value: T | undefined
): T | typeof EMPTY_LOCAL_STREAM_VALUE {
    return value ?? EMPTY_LOCAL_STREAM_VALUE;
}
